import { render, staticRenderFns } from "./mobi-footer.vue?vue&type=template&id=0eacd1c0&scoped=true&"
import script from "./mobi-footer.vue?vue&type=script&lang=js&"
export * from "./mobi-footer.vue?vue&type=script&lang=js&"
import style0 from "./mobi-footer.vue?vue&type=style&index=0&id=0eacd1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eacd1c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
